<template>
  <Modal id="AttendanceLogsDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('attendanceLogs.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('attendanceLogs.field.id_att_log')">{{data.idAttLog}}</DescriptionsItem>
      <DescriptionsItem :label="$t('attendanceLogs.field.id_emp')">{{data.employeeNameTw}}</DescriptionsItem>
      <DescriptionsItem :label="$t('attendanceLogs.field.check_time')">{{data.checkTime}}</DescriptionsItem>
      <DescriptionsItem :label="$t('attendanceLogs.field.verify_mode')">{{data.verifyMode}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "AttendanceLogsDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>